import axios from 'axios';
import { API_URL } from '../Auth/constansts';

const SetGrupCreate = async (
    token,
    companyid,
    name,
    description,
    user,
    show
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            name +
            description +
            user +
            show + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/setgruop`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                name: name,
                description: description,
                user: user,
                show: show,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const SetStudentList = async (
    token,
    companyid,
    group,
    students,
    year,
    moth,
    day,
    hour,
    minutes
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            group +
            JSON.stringify(students) +
            year +
            moth +
            day +
            hour +
            minutes + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/studentlist`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                group: group,
                students: JSON.stringify(students),
                year: year,
                moth: moth,
                day: day,
                hour: hour,
                minutes: minutes,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const SetGrupEdit = async (
    token,
    companyid,
    groupid,
    name,
    description,
    user,
    show
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            groupid +
            name +
            description +
            user +
            show + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/setgruopE`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                groupid: groupid, 
                name: name,
                description: description,
                user: user,
                show: show,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const ListGruopDataAPI = async (token, companyid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/getgruops`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const GetGruopDataAPI = async (token, companyid, gruopid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/getgruop`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                gruopid: gruopid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const GetEstudentsDataIDAPI = async (token, companyid, gruopid, studentid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/dataestudent`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                gruopid: gruopid,
                id:studentid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const GetEstudentsDataAPI = async (token, companyid, gruopid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/getstudents`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                gruopid: gruopid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const GetEstudentsArrayDataAPI = async (token, companyid, gruopid, array) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/getstudentsArray`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                gruopid: gruopid,
                estudents:array
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}


const SetEstudentCreate = async (
    token,
    companyid,
    gruopid,
    code,
    lastname,
    firstname,
    email,
    active
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            gruopid +
            code +
            lastname +
            firstname +
            email +
            active + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/setstudent`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                gruopid: gruopid,
                code: code,
                lastname: lastname,
                firstname: firstname,
                email: email,
                active: active,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}


const SetEstudentEdit = async (
    token,
    companyid,
    gruopid,
    studentid,
    code,
    lastname,
    firstname,
    email,
    active
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            gruopid +
            studentid +
            code +
            lastname +
            firstname +
            email +
            active + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/setstudentE`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                gruopid: gruopid,
                studentid:studentid,
                code: code,
                lastname: lastname,
                firstname: firstname,
                email: email,
                active: active,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}


const SetEstudentArrayCreate = async (
    token,
    companyid,
    gruopid,
    dataIn
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            gruopid +
            JSON.stringify(dataIn) + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/setstudentarray`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                gruopid: gruopid,
                data: JSON.stringify(dataIn),
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const SetActivityCreate = async (
    token,
    companyid,
    groupid,
    activityid,
    nombre,
    descripcion,
    dia,
    mes,
    an_o,
    peso,
    show,
) => {
    try {
        const dateSend = an_o + "-" + mes + "-" + dia;
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            groupid +
            nombre +
            descripcion +
            dateSend +
            peso +
            show +
            activityid + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/setactivities`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                gruopid: groupid,
                name: nombre,
                description: descripcion,
                date: dateSend,
                weigth: peso,
                show: show,
                principal: activityid,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}


const SetActivityEdit = async (
    token,
    companyid,
    groupid,
    activityid,
    nombre,
    descripcion,
    dia,
    mes,
    an_o,
    peso,
    show,
) => {
    try {
        const dateSend = an_o + "-" + mes + "-" + dia;
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            groupid +
            nombre +
            descripcion +
            dateSend +
            peso +
            show +
            activityid + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/setactivitiesE`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                gruopid: groupid,
                activityid: activityid,
                name: nombre,
                description: descripcion,
                date: dateSend,
                weigth: peso,
                show: show,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}


const GetActivitiesDataAPI = async (token, companyid, gruopid, principalActivity) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/getactivities`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                gruopid: gruopid,
                principal: principalActivity
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const GetStudentListAPI = async (token, companyid, group) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/studentlistshow`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                group: group
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const GetActivityDataAPI = async (token, companyid, principalActivity) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/getactivity`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                principal: principalActivity
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}


const SetPointCreate = async (
    token,
    companyid,
    activityid,
    text,
    weigth
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            activityid +
            text +
            weigth + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/setpoints`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                activityid: activityid,
                text: text,
                weigth: weigth,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const UpdatePointCreate = async (
    token,
    companyid,
    pointid,
    activityid,
    text,
    weigth
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            pointid +
            activityid +
            text +
            weigth + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/updatepoint`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                pointid: pointid,
                activityid: activityid,
                text: text,
                weigth: weigth,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const GetPointsDataAPI = async (token, companyid, activityid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/getpoints`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                activityid: activityid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const GetPointDataAPI = async (token, companyid, activityid, pointid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/getpoint`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                activityid: activityid,
                pointid: pointid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const SetBonoCreate = async (
    token,
    companyid,
    activityid,
    name,
    value,
    show
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            activityid +
            name +
            value +
            show + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/setbonos`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                activityid: activityid,
                name: name,
                value: value,
                show: show,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const GetBonosDataAPI = async (token, companyid, activityid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/getbonos`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                activityid: activityid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const Calificar = async (
    token,
    companyid,
    activityid,
    dataIn
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            activityid +
            JSON.stringify(dataIn) + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/calificarall`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                activityid: activityid,
                data: JSON.stringify(dataIn),
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const CalificarGroup = async (
    token,
    companyid,
    activityid,
    estudentArray,
    gradeArray
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            activityid +
            JSON.stringify(estudentArray) +
            JSON.stringify(gradeArray) + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/calificargroup`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                activityid: activityid,
                estudent: JSON.stringify(estudentArray),
                grade: JSON.stringify(gradeArray),
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const CalificarBonoGroup = async (
    token,
    companyid,
    activityid,
    estudentArray,
    gradeArray
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            activityid +
            JSON.stringify(estudentArray) +
            JSON.stringify(gradeArray) + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/calificarbonogroup`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                activityid: activityid,
                estudent: JSON.stringify(estudentArray),
                grade: JSON.stringify(gradeArray),
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const GetGradeActivitiesDataAPI = async (token, companyid, gruopid, principalActivity) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/calificarshow`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                gruopid: gruopid,
                activity: principalActivity
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const GetGrooupStudentDataAPI = async (clave, code) => {
    try {
        const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/dataestudent?clave=${clave}&codigo=${code}`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}


const GetGrooupStudentActivityDataAPI = async (clave, student, activity) => {
    try {
        const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${API_URL}/academic/dataestudentactivity?clave=${clave}&student=${student}&activity=${activity}`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

export {
    SetGrupCreate,
    SetStudentList,
    GetStudentListAPI,
    SetGrupEdit,
    ListGruopDataAPI,
    GetGruopDataAPI,
    SetEstudentCreate,
    SetEstudentEdit,
    SetEstudentArrayCreate,
    GetEstudentsDataAPI,
    GetEstudentsDataIDAPI,
    GetEstudentsArrayDataAPI,
    SetActivityCreate,
    SetActivityEdit,
    GetActivitiesDataAPI,
    GetActivityDataAPI,
    SetPointCreate,
    UpdatePointCreate,
    GetPointsDataAPI,
    GetPointDataAPI,
    SetBonoCreate,
    GetBonosDataAPI,
    Calificar,
    CalificarGroup,
    CalificarBonoGroup,
    GetGradeActivitiesDataAPI,
    GetGrooupStudentDataAPI,
    GetGrooupStudentActivityDataAPI
}